import { type MetricField } from "../../../gql-generated/types";
import { getKeys } from "../../../shared/utils/object";
import { funnelAnalysisFieldsWithDimensionsCascadingOrderMap } from "../metricsFields";

import { type Dimension, dimensionLabelsMap } from "./dimensionLabels";

export const NOT_ENOUGH_MESSAGE = "Not Enough Data";

export interface FunnelItem {
    value: number;
    valueFormatted: string;
    fractionFromPreviousPercent: number;
    fractionFromPreviousPercentFormatted: string;
    fractionFromTotalPercent: number;
    fractionFromTotalPercentFormatted: string;
    isMapEmpty: boolean;
    label: string;
    labelPrevious: string | null;
}
// TODO(kkold) - Remove partial
export type FunnelSlice = Partial<Record<MetricField, FunnelItem>>;
export type DimensionFunnel = Record<string, FunnelSlice>;
export type DimensionFunnelMap = Record<string, DimensionFunnel>;

export type RendererProps = Partial<{
    x: number;
    y: number;
    width: number;
    height: number;
    value: number;
    fill: string;
    radius: number | [number, number, number, number];
    index: number;
    payload: FunnelItem;
}>;

export const defaultFunnelItem: Readonly<FunnelItem> = {
    value: 0,
    valueFormatted: NOT_ENOUGH_MESSAGE,
    fractionFromPreviousPercent: 0,
    fractionFromPreviousPercentFormatted: "0.00%",
    fractionFromTotalPercent: 0,
    fractionFromTotalPercentFormatted: "0.00%",
    isMapEmpty: true,
    label: "",
    labelPrevious: "",
};

export const createDefaultFunnelSlice = (): FunnelSlice => {
    const funnelSlice: FunnelSlice = {};
    const metricFields = getKeys(funnelAnalysisFieldsWithDimensionsCascadingOrderMap);
    for (const metricField of metricFields) {
        funnelSlice[metricField] = { ...defaultFunnelItem };
    }

    return funnelSlice;
};

export const createDefaultDimensionFunnel = (dimension: Dimension): DimensionFunnel => {
    const dimensionFunnel: DimensionFunnel = {};
    for (const key of getKeys(dimensionLabelsMap[dimension])) {
        dimensionFunnel[key] = createDefaultFunnelSlice();
    }

    return dimensionFunnel;
};

export const createDefaultDimensionsFunnelMap = (): DimensionFunnelMap => {
    const dimensionsFunnelMap: DimensionFunnelMap = {};

    for (const key of getKeys(dimensionLabelsMap)) {
        dimensionsFunnelMap[key] = createDefaultDimensionFunnel(key);
    }

    return dimensionsFunnelMap;
};

export const DIMENSION_FUNNEL_METRIC_MINIMUM = 30;
